import APIService from '@/services/APIService';

export default function (url) {
  return {
    index: (params, rOptions) => APIService.get(url, { params, rOptions }),

    show: (id) => APIService.get(`${url}/${id}`),

    create: (data) => APIService.post(url, data),

    update: (id, data) => APIService.put(`${url}/${id}`, data),

    delete: (id) => APIService.delete(`${url}/${id}`),
  };
}
